module.exports = ".footer{\r\n    background: #000;\r\n    color:#fff;\r\n    position: absolute;\r\n    bottom:0;\r\n    left:0;\r\n    right:0;\r\n    width:100%;\r\n    font-size:12px;\r\n    padding:10px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/footer/footer.component.css
// module id = ./src/app/common/footer/footer.component.css
// module chunks = main